<template>
  <section class="form-list">
    <el-form
        ref="form"
        :rules="rules"
        :model="postData"
        label-position="right"
        label-width="150px"
        class="form"
    >
      <el-form-item label="检索对象">
        <el-radio v-model="is_title_sub" :label="false">商品标题</el-radio>
        <el-radio v-model="is_title_sub" :label="true">商品副标题</el-radio>
      </el-form-item>

      <el-form-item v-if="is_title_sub" label="关键词" prop="title_sub">
        <el-input
            v-model="postData.title_sub"
            maxlength="21"
            show-word-limit
            clearable
            placeholder="请输入副标题关键词"
        />
        <el-alert
            title="当有赞商品副标题包含此关键词，则在下方设置的日期可签到"
            type="info"
            show-icon
            :closable="false"
        />
      </el-form-item>
      <el-form-item v-else label="关键词" prop="title">
        <el-input
            v-model="postData.title"
            maxlength="21"
            show-word-limit
            clearable
            placeholder="请输入标题关键词"
        />
        <el-alert
            title="当有赞商品标题包含此关键词，则可签到"
            type="info"
            show-icon
            :closable="false"
        />
      </el-form-item>

      <el-form-item label="可签到日期" prop="sign_date">
        <el-date-picker
            v-model="postData.sign_date"
            :picker-options="pickerOptionsOfAfterSystemStartDay"
            type="date"
            value-format="yyyy-MM-dd"
            align="right"
            placeholder="请选择所属日期"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSubmit" :loading="isSaving">保存修改</el-button>
        <el-button @click="RouteConfig.youZanSignDateList.back">返回</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { show, update } from '@/api/you-zan-sign-date';
import { pickerOptionsOfAfterSystemStartDay } from "@/utils/formats";
import { timeToYmd } from "@/filters";

export default {
  name: RouteConfig.youZanSignDateEdit.name,
  data: () => ({
    RouteConfig,
    pickerOptionsOfAfterSystemStartDay,
    is_title_sub: false,
    isSaving: false,
    postData: {
      update_time: 0,
      title: '',
      title_sub: '',
      sign_date: '',
    },
    rules: {
      title: [{ required: true, message: '请输入标题关键词', trigger: 'change' }],
      title_sub: [{ required: true, message: '请输入副标题关键词', trigger: 'change' }],
      sign_date: [{ required: true, message: '请选择可签到日期', trigger: 'change' }],
    },
  }),
  computed: {
    id() {
      return +this.$route.params.id || 0;
    },
  },
  beforeMount() {
    this.show();
  },
  methods: {
    handleSubmit() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        this.isSaving = true;
        const { is_title_sub } = this;
        const updateData = { ...this.postData };
        if (is_title_sub) {
          updateData.title = '';
        } else {
          updateData.title_sub = '';
        }

        const { isError } = await update(this.id, updateData);
        this.isSaving = false;
        if (!isError) RouteConfig.youZanSignDateList.back();
      });
    },
    async show() {
      const { isError, data } = await show(this.id);
      if (isError) return;

      data['sign_date'] = data['sign_date'] ? timeToYmd(data['sign_date']) : '';
      const { postData } = this;
      const updateData = {};
      Object.keys(data).forEach(key => {
        if (key in postData) updateData[key] = data[key];
      });

      this.is_title_sub = !!updateData['title_sub'];
      Object.assign(postData, updateData);
    },
  },
};
</script>
